import { render, staticRenderFns } from "./QZ02.vue?vue&type=template&id=f143520a&scoped=true"
import script from "./QZ02.vue?vue&type=script&lang=js"
export * from "./QZ02.vue?vue&type=script&lang=js"
import style0 from "./QZ02.vue?vue&type=style&index=0&id=f143520a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143520a",
  null
  
)

export default component.exports